export default {
  setCampaign: ({ commit }, payload) => {
    commit('SET_CAMPAIGN', payload)
  },

  setUpdateCv: ({ commit }, payload) => {
    commit('SET_UPDATE_CV', payload)
  }
}
